import { defineMessages } from 'react-intl-next';

export default defineMessages({
	modalTitle: {
		id: 'dev-agents.home.code-reviewer-settings.modal-title',
		defaultMessage: 'Choose a workspace to enable Code Reviewer',
		description:
			'The title of the modal that allows users to choose a workspace to enable Code Reviewer.',
	},
});
